import AbstractSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Contract from "slotworks/utils/contract";
import AnimatedSprite from "slotworks/graphics/animation/animated-sprite";
import Rectangle from "slotworks/utils/geom/rectangle";
import graphicsManager from "slotworks/graphics/graphics-manager";
import Layers from "slotworks/graphics/layers/layers";
import soundManager from "slotworks/sound/sound-manager";

const HIGHS = ["8", "TOAD", "GOLD", "COIN", "MONEYP"];

export default class LowToHighSymbolBehaviour extends AbstractSymbolBehaviour {

    public static ANIMATE_BEHIND: boolean = false;

    protected masterSymbol: string = "symbol_1_1";

    protected defaultAnimation: string;

    protected animation: AnimatedSprite;

    private offset: Rectangle;

    private completeResolve: () => void;

    constructor(symbol: SymbolComponent, defaultAnimation: string = "symbol_high_to_low") {
        super(symbol);
        this.defaultAnimation = defaultAnimation;
    }

    public static() {
        this.cleanUp();
    }

    public stop(): Contract<void> {
        const id = HIGHS[Math.floor(Math.random() * HIGHS.length)];
        return this.animate("symbol_high_to_low", id);
    }

    public updateTransform(): void {
        super.updateTransform();

        if (this.behaviourSprite) {
            this.behaviourSprite.x += this.offset.x;
            this.behaviourSprite.y += this.offset.y;
            this.behaviourSprite.width *= this.offset.width;
            this.behaviourSprite.height *= this.offset.height;

            // Adjust for if this is the middle of a stack
            const stackOffset = this.symbol.getStackOffsetY();
            if (stackOffset) {
                this.behaviourSprite.y -= stackOffset;
            }
        }
    }

    protected animate(defaultAnimation: string, id: string) {

        if (this.completeResolve) {
            this.completeResolve();
        }
        this.cleanUp();

        let animation: AnimatedSprite = graphicsManager.createAnimation(defaultAnimation);

        if (!animation) {
            return Contract.empty();
        }

        animation.stop();
        animation.visible = false;

        this.symbol.setLayer(Layers.SymbolAnimations);
        Layers.SymbolAnimations.add(animation, false, false);

        this.behaviourSprite = animation;

        // Calculate relative size for animation versus static
        const masterRect = Layers.MatrixContent.getPosition(this.masterSymbol);
        let animRect;

        // animNameList.push(this.symbol.symbolId);
        // while (!animRect && animNameList.length > 0) {
        //     animRect = Layers.MatrixContent.getPosition(animNameList.shift());
        // }
        animRect = Layers.MatrixContent.getPosition(defaultAnimation);

        if (!animRect) {
            animRect = new Rectangle(0, 0, animation.width, animation.height);
        }

        const offsetX = animRect.x - masterRect.x;
        const offsetY = animRect.y - masterRect.y;
        this.offset = new Rectangle(offsetX, offsetY, animRect.width / masterRect.width, animRect.height / masterRect.height);
        this.updateTransform();
        this.behaviourSprite.visible = true;
        animation.loop = false;
        this.animation = animation;

        return new Contract<void>((resolve) => {
            soundManager.customEvent("symbols_high_low");
            
            animation.gotoAndPlay(0);     
            this.completeResolve = () => resolve(null);
            let updated = false;
            animation.onFrameChange = () => {
                if(!updated && animation && animation.currentFrame > 8) {
                    this.symbol.setSymbol(id);
                    this.symbol.updateTransform();
                    updated = true;
                }
            }

            animation.onComplete = () => {
                animation.stop();
                animation.visible = false;
                Layers.SymbolAnimations.remove(this.animation);
            //    if (autoReset) {
                    this.symbol.setLayer(Layers.MatrixContent);
                    animation = null;
            //    }
                if (this.completeResolve) {
                    this.completeResolve();
                    this.completeResolve = null;
                }
            };
        });
    }

    private cleanUp() {
        if (this.animation) {
            this.animation.onComplete = null;
            this.animation.stop();
            Layers.SymbolAnimations.remove(this.animation);
            this.animation = null;
            this.symbol.setLayer(Layers.MatrixContent);
            this.completeResolve = null;
        }
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/components/matrix/symbols/low-to-high-symbol-behaviour.ts